import script from "./layout-page.vue?vue&type=script&setup=true&lang=js"
export * from "./layout-page.vue?vue&type=script&setup=true&lang=js"

import "./layout-page.vue?vue&type=style&index=0&id=dec5e304&lang=css"

const __exports__ = script;

export default __exports__